import React from "react";
import { useLoopingCountdown } from "../hooks/useLoopingCountdown";
const START_SECONDS = 17 * 60 + 34; // 00:17:34

export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useLoopingCountdown(START_SECONDS);
  const units = [{
    label: "Hours",
    value: hours
  }, {
    label: "Minutes",
    value: minutes
  }, {
    label: "Seconds",
    value: seconds
  }];
  return <div className="w-full rounded-2xl bg-navy px-3 py-4 text-center md:p-5" role="timer" aria-live="off" data-id="element-26" data-mp="3c25qz8vjxxzj">
      <p className="font-display text-sm font-extrabold uppercase tracking-wide text-gold" data-id="element-27" data-mp="3h0pbr5yet3qb">
        The promotional price ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-1.5 md:gap-2" data-id="element-28" data-mp="3259g4wi6kzrt">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-29" data-mp="3731heh4pty8o" data-mpi={i}>
            <div className="flex w-16 flex-col items-center md:w-20" data-id="element-30" data-mp="10clayhlz829e">
              <span className="w-full rounded-xl bg-white py-2 font-display text-3xl font-black tabular-nums text-navy md:text-4xl" data-id="element-31" data-mp="10a8xagn94e25">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wide text-brand-soft" data-id="element-32" data-mp="xytvycxw8v45">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-1.5 font-display text-3xl font-black text-white md:text-4xl" aria-hidden="true" data-id="element-33" data-mp="17q6l2wsb576h">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}